module.exports = new Promise(resolve => {
      // This part depends on how you plan on hosting and versioning your federated modules
      const remoteUrl = window.origin + '/fsp-mfe/remoteEntry.js'
      const script = document.createElement('script')
      script.src = remoteUrl
      script.onload = () => {
        // the injected script has loaded and is available on window
        // we can now resolve this Promise
        const proxy = {
          get: (request) => window.fspApp.get(request),
          init: (arg) => {
            try {
              return window.fspApp.init(arg)
            } catch(e) {
              console.log('remote container already initialized')
            }
          }
        }
        resolve(proxy)
      }
      // inject this script with the src set to the versioned remoteEntry.js
      document.head.appendChild(script);
    })
    ;